import { Inject, Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthContextStorageService } from '../auth-context-storage.service'
import { AuthService } from '../auth.service'

/**
 * LoginGuard - Redirects authenticated users away from login page
 *
 * Applied to /login route to redirect already authenticated users to landing page.
 */
@Injectable({ providedIn: 'root' })
export class LoginGuard  {

    constructor(
        @Inject(AuthContextStorageService) private authContext: AuthContextStorageService,
        @Inject(AuthService) private authService: AuthService,
        @Inject(Router) private router: Router
    ) {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Skip auto-login during logout — user is intentionally navigating to /login
        if (this.authService.isLoggingOut) {
            return true
        }

        if (this.authContext.isAuthenticated()) {
            return this.router.parseUrl('/landingPage')
        }

        return this.authService.onStartup()
            .then(() => {
                if (this.authContext.isAuthenticated()) {
                    return this.router.parseUrl('/landingPage')
                }
                return true
            })
            .catch(() => {
                return true
            })
    }
}